import { Stack } from "@mui/material";

type Props = {
  currentQuestion: any;
};

const NumberField = ({ currentQuestion }: Props) => {
  const { properties, responses } = currentQuestion;

  return (
    <Stack gap={1} direction={"row"} alignItems={"center"}>
      <div style={{ fontSize: "14px" }}>
        {responses?.[0]?.numberValue || ""}
      </div>
      {properties.measurementUnit && <div>{properties?.measurementUnit}</div>}
    </Stack>
  );
};
export default NumberField;
